import * as React from 'react';
import Input from '@material-ui/core/Input';
import { List, ListItem, ListItemText } from '@material-ui/core';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import { searchPlaces, fetchPlaceCoordinates } from '../services';
import { matchCoordinatesFormat } from '../utils';
import { ListItemSecondaryAction } from '@material-ui/core';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles: StyleRulesCallback = theme => ({
  root: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    height: '100%'
  },
  list: {
    overflow: 'auto'
  },
  selectedItem: {
    backgroundColor: theme.palette.grey['200']
  }
});

interface Props {
  selectedKey: string | null;
  onSelect: (key: string, coords: [number, number]) => void;
  onResultsChange: () => void;
}

interface State {
  hint: string;
  results: SearchPlacesResult[];
}

class PlaceInput extends React.Component<Props & WithStyles, State> {
  state = {
    hint: '',
    results: []
  };

  timeout = 0;

  handleInput = (
    event: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.preventDefault();

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    const hint = event.currentTarget.value;
    this.setState({ hint });

    const coords = matchCoordinatesFormat(hint);
    if (coords) {
      this.doUpdateResults([
        {
          key: `${coords[0]},${coords[1]}`,
          primary: coords.join(', '),
          secondary: 'Coordenadas',
          coords
        }
      ]);
    } else {
      this.timeout = window.setTimeout(() => this.doSearchPlaces(), 500);
    }
  };

  async doSearchPlaces() {
    try {
      const results = await searchPlaces(this.state.hint);
      this.doUpdateResults(results);
    } catch (err) {
      console.log(err);
    }
  }

  doUpdateResults(results: SearchPlacesResult[]) {
    this.setState({ results });
    this.props.onResultsChange();
  }

  handleSelectResult = async (result: SearchPlacesResult) => {
    if (result.coords) {
      this.props.onSelect(result.key, result.coords);
    }

    if (result.placeId) {
      const coords = await fetchPlaceCoordinates(result.placeId);
      this.props.onSelect(result.key, coords);
    }
  };

  renderResultItem(result: SearchPlacesResult) {
    const { classes, selectedKey } = this.props;

    const isSelected = result.key === selectedKey;

    return (
      <ListItem
        key={result.key}
        divider={true}
        button={true}
        className={isSelected ? classes.selectedItem : undefined}
        onClick={() => this.handleSelectResult(result)}
      >
        <ListItemText primary={result.primary} secondary={result.secondary} />
        {isSelected && (
          <ListItemSecondaryAction>
            <CheckCircleIcon />
          </ListItemSecondaryAction>
        )}
      </ListItem>
    );
  }

  renderResultList() {
    const { results } = this.state;

    if (!results || !results.length) {
      return null;
    }

    return this.state.results.map(r => this.renderResultItem(r));
  }

  render() {
    const { classes } = this.props;
    return (
      <main className={classes.root}>
        <Input
          fullWidth={true}
          type="search"
          placeholder="Buscar por región ó coordenadas"
          onChange={this.handleInput}
          value={this.state.hint}
        />
        <List component="nav" className={classes.list}>
          {this.renderResultList()}
        </List>
      </main>
    );
  }
}

export default withStyles(styles)(PlaceInput);



// WEBPACK FOOTER //
// ./src/components/PlaceInput.tsx